// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3eHjN","right":"Footer_right__3r-qd","buttons":"Footer_buttons__1Uupj"};